import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useMaterialUIController } from "./context";
import { useEffect, useState } from "react";
import {
  Alert,
  CssBaseline,
  GlobalStyles,
  Snackbar,
  ThemeProvider,
} from "@mui/material";
import theme from "./assest/theme";
import Sidenav from "./layoutcontainers/DashboardLayout/components/Sidebar";
import routes from "./routes";
import logo from "../src/assest/Soucient1.png";
import CircleLoading from "./components/Loading/CircleLoading";
import { useLoading } from "./context/loadingcontext";
import { useAuth } from "./context/AuthContext";
import "./app.css";
import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "./firebase";
import { BASE_URL } from "./pages/Utils/Baseurl";
import DashboardCalendar from "./pages/Home/DashboardCalendar";



const scrollbarStyles = {
  "*::-webkit-scrollbar": {
    width: "6px", // Reduced from 8px
    height: "6px", // Reduced from 8px
  },
  "*::-webkit-scrollbar-track": {
    background: "#f1f1f1",
    borderRadius: "4px",
  },
  "*::-webkit-scrollbar-thumb": {
    background: "#888",
    borderRadius: "4px",
  },
  "*::-webkit-scrollbar-thumb:hover": {
    background: "#555",
  },
  html: {
    scrollbarWidth: "thin", // Kept as 'thin' for Firefox
    scrollbarColor: "#888 #f1f1f1",
  },
};

function App() {
  // const { rolePermission } = useAuth();
  const rolePermission = JSON.parse(sessionStorage.getItem("role"));
  const { authenticated, setAuthenticated } = useAuth();
  const [controller] = useMaterialUIController();
  const { direction, layout, sidenavColor } = controller;
  const { pathname } = useLocation();
  const { circleLoading } = useLoading();
  const [chatBotStatus, setChatBotStatus] = useState(true);
  const [open, setOpen] = useState(false);
  const [notification, setNotification] = useState({ title: "", body: "" });
  const currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
  const team = sessionStorage.getItem("team");

  useEffect(() => {
    const unsubscribe = onMessage(messaging, (payload) => {

      const { title, body } = payload.notification;
      setNotification({ title, body });
      setOpen(true);
    });

    return () => unsubscribe();
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    Notification.requestPermission().then((permission) => {
      if (permission === "granted") {
        getToken(messaging, {
          vapidKey:
            "BGECpU5qxCQMyY8b47T_t-JYoinceBDpfncdDRiL0Dg1tf4GeNHvsjD183Oku9KKwWhhHWL_nONizRcoOuHocwA",
        })
          .then((currentToken) => {
            if (currentToken) {

              fetch(`${BASE_URL}api/store-token/`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  token: currentToken,
                  device_type: "web",
                  user: currentUser,
                }),
              });
            } else {
              console.log(
                "No registration token available. Request permission to generate one."
              );
            }
          })
          .catch((err) => {
            console.error("An error occurred while retrieving token. ", err);
          });
      }
    });


    onMessage(messaging, (payload) => {
      alert(
        `Notification: ${payload.notification.title} - ${payload.notification.body}`
      );
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="info" sx={{ width: "100%" }}>
          <strong>{payload.notification.title}</strong>:{" "}
          {payload.notification.body}
        </Alert>
      </Snackbar>;
    });
  }, []);

  //Role Permissions

  const allowedModules = rolePermission
    ?.filter((p) => p.can_access)
    .map((p) => p.module_name);


  const filterSidebarItems = (items, allowedModules, userTeam) => {
    const restrictedQaModules = [
      "Project Insights",
      "Test Plan",
      "Test Case",
      "Test Run",
      "Reports",
    ];

    return items
      .map((item) => {
        // Check if the item is a restricted QA module
        const isRestrictedQa = (moduleName) => restrictedQaModules.includes(moduleName);

        // If user is not in Testing Team, filter out restricted QA modules
        if (userTeam !== "Testing Team") {
          if (isRestrictedQa(item.permissionModule)) {
            return null;
          }
        }

        // If item has sub-items (collapse)
        if (item.collapse) {
          const filteredCollapse = item.collapse?.filter((sub) => {
            const isAllowedByRole =
              !sub.permissionModule ||
              allowedModules?.includes(sub.permissionModule);

            const isAllowedByTeam =
              userTeam === "Testing Team" || !isRestrictedQa(sub.permissionModule);

            return isAllowedByRole && isAllowedByTeam;
          });

          if (filteredCollapse?.length > 0) {
            return { ...item, collapse: filteredCollapse };
          }

          return null; // Don't show the parent if no allowed children
        }

        // If item has no sub-items (flat route)
        const isAllowedByRole =
          !item.permissionModule ||
          allowedModules?.includes(item.permissionModule);

        const isAllowedByTeam =
          userTeam === "Testing Team" || !isRestrictedQa(item.permissionModule);

        if (isAllowedByRole && isAllowedByTeam) {
          return item;
        }

        return null;
      })
      .filter(Boolean); // Remove nulls
  };

  const filteredSidebar = filterSidebarItems(routes, allowedModules, team);


  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  useEffect(() => {
    if (pathname === "/sign-in") {
      sessionStorage.clear();
      setAuthenticated(false);
    }
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);


  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return (
          <>
            {route.route === "/sign-in" ||
              route.route === "/forgot-password" ||
              route.route === "password-reset-confirm/:uidb64/:token" ? (
              <Route
                exact
                path={route.route}
                element={route.component}
                key={route.key}
              />
            ) : (
              authenticated && (
                <Route
                  exact
                  path={route.route}
                  element={route.component}
                  key={route.key}
                />
              )
            )}
          </>
        );
      }

      return null;
    });


  return (

    <ThemeProvider theme={theme}>
      <GlobalStyles styles={scrollbarStyles} />
      <CssBaseline />
      {layout === "dashboard" && (
        <>
          <Sidenav
            color={sidenavColor}
            brand={logo}
            brandName="Keelis"
            routes={filteredSidebar}
          />
        </>
      )}
      {circleLoading && (
        <div className="loading-context-box">
          <CircleLoading />
        </div>
      )}

      <Routes>
        {getRoutes(filteredSidebar)}
        <Route
          path="*"
          element={
            <Navigate
              to={authenticated ? "/employee-dashboard" : "/sign-in"}
            />
          }
        />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
